import { io } from "socket.io-client";
import config, { AUTH_TOKEN_KEY } from "../config";

let socket = null;
const messageCallbacks = new Set();
const historyCallbacks = new Set();
const viewerCountCallbacks = new Set();
const giftCallbacks = new Set();
const errorCallbacks = new Set();


const connect = (token) => {
  if (socket) {
    disconnect();
  }

  // Подключаемся к namespace /stream
  socket = io(`${config.API_BASE_URL}/stream`, {
    path: "/socket.io",
    auth: { token },
    transports: ["websocket", "polling"],
  });

  setupEventListeners();
};

const setupEventListeners = () => {
  socket.on("connect", () => {
    console.log("[StreamChatService] Connected to /stream namespace");
  });

  socket.on("disconnect", () => {
    console.log("[StreamChatService] Disconnected from stream server");
  });

  // Новое сообщение в чате стрима
  socket.on("new-message-stream", (data) => {
    console.log("[StreamChatService] New message received:", data);
    messageCallbacks.forEach((callback) =>
      callback({
        type: "message",
        data: data.message,
      })
    );
  });

  // История чата при входе в стрим
  socket.on("stream-chat-history", (data) => {
    console.log("[StreamChatService] Chat history received:", data);
    historyCallbacks.forEach((callback) => callback(data));
  });

  // Обновление количества зрителей
  socket.on("viewer-count", (data) => {
    console.log("[StreamChatService] Viewer count updated:", data);
    viewerCountCallbacks.forEach((callback) => callback(data));
  });

  // Получен подарок
  socket.on("gift-sent", (data) => {
    console.log("[StreamChatService] Gift received:", data);
    giftCallbacks.forEach((callback) => callback(data));
  });

  // Ошибки
  socket.on("error", (error) => {
    console.error("[StreamChatService] Socket error:", error);
    errorCallbacks.forEach((callback) => callback(error));
  });
};

const disconnect = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

// Присоединиться к стриму
const joinStream = (streamId) => {
  console.log("[StreamChatService] Joining stream:", streamId);
  if (!socket) {
    throw new Error("Socket not connected");
  }
  socket.emit("join-stream", { streamId });
};

// Покинуть стрим
const leaveStream = (streamId) => {
  console.log("[StreamChatService] Leaving stream:", streamId);
  if (!socket) {
    throw new Error("Socket not connected");
  }
  socket.emit("leave-stream", { streamId });
};

// Отправить сообщение в чат стрима
const sendMessage = (streamId, message) => {
  console.log("[StreamChatService] Sending message to stream:", streamId);
  if (!socket) {
    throw new Error("Socket not connected");
  }
  socket.emit("send-message-stream", { streamId, message });
};

// Отправить подарок стримеру
const sendGift = (streamId, giftId, payload = null) => {
  console.log("[StreamChatService] Sending gift to stream:", streamId, giftId);
  if (!socket) {
    throw new Error("Socket not connected");
  }
  socket.emit("send-gift-stream", { streamId, giftId, payload });
};

// Подписка на новые сообщения
const onMessage = (callback) => {
  messageCallbacks.add(callback);
  return () => messageCallbacks.delete(callback);
};

// Подписка на историю чата
const onHistory = (callback) => {
  historyCallbacks.add(callback);
  return () => historyCallbacks.delete(callback);
};

// Подписка на обновления количества зрителей
const onViewerCount = (callback) => {
  viewerCountCallbacks.add(callback);
  return () => viewerCountCallbacks.delete(callback);
};

// Подписка на подарки
const onGift = (callback) => {
  giftCallbacks.add(callback);
  return () => giftCallbacks.delete(callback);
};

// Подписка на ошибки
const onError = (callback) => {
  errorCallbacks.add(callback);
  return () => errorCallbacks.delete(callback);
};

// Проверка подключения
const isConnected = () => {
  return socket?.connected || false;
};

const streamChatService = {
  connect,
  disconnect,
  joinStream,
  leaveStream,
  sendMessage,
  sendGift,
  onMessage,
  onHistory,
  onViewerCount,
  onGift,
  onError,
  isConnected,
  // Обратная совместимость со старым API
  joinStreamChat: joinStream,
};

export default streamChatService;
